import {Info} from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Typography,
} from '@mui/material';
import {useState} from 'react';
import {useRqNoPlayByMediaTrack} from '../../../react_query/no-play/NoPlayList';
import {DialogClose} from '../../../components/dialogs/DialogFrame/DialogClose';
import {NoPlayListRating} from '../../../dto/NoPlayList.dto';

export const NoPlayInfoButton = ({id}: {id: number}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        title='The Reasons why the song is unavailable'
        onClick={() => setIsOpen(true)}>
        <Info />
      </IconButton>
      {isOpen && (
        <NoPlayInfoDialog id={id} isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
    </>
  );
};

const NoPlayInfoDialog = ({
  id,
  isOpen,
  setIsOpen,
}: {
  id: number;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {data, isFetching} = useRqNoPlayByMediaTrack(id);

  return (
    <Dialog open={isOpen} maxWidth='md' onClose={() => setIsOpen(false)}>
      <DialogTitle>
        <Typography>Reasons for Song Rejection</Typography>
        <DialogClose onClose={() => setIsOpen(false)} />
      </DialogTitle>
      <DialogContent sx={{pt: 2}}>
        {isFetching ? (
          <Skeleton width={400} />
        ) : data ? (
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='h5' sx={{ minWidth: 350 }}>
                  {data.song_name} by {data.artist_name}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {data.no_play_list_ratings.length === 0 ? (
                  <Typography>No ratings provided</Typography>
                ) : (
                  <List>
                    {data.no_play_list_ratings.map(
                      (rating: NoPlayListRating) => (
                        <ListItem key={rating.id}>
                          <ListItemText primary={rating.description} />
                        </ListItem>
                      ),
                    )}
                  </List>
                )}
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Typography>This track has been in the No-play list</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
